import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Evaluation/EvaluationModels/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class EvalModelsQueries extends VueCqrs
{
	runEvalModelsPageQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildEvalModelsPageQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runEvalModelByIdQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildEvalModelByIdQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}
}